import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import quizQuestions from 'react/app/api/quizQuestions';
import {Link} from 'react-router';

function Result(props) {

    return (
        <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
        >
      <div>
          <div className="col-lg-3 col-md-6">
              <div className="card-box widget-box-two widget-two-primary">
                  <i className="mdi mdi-check widget-two-icon"></i>
                  <div className="wigdet-two-content text-white">
                      <p className="m-0 text-uppercase font-600 font-secondary text-overflow" title="Statistics">Score</p>
                      <h2 className="text-white"><span data-plugin="counterup">{props.quizResult} /{quizQuestions.length}</span></h2>
                      <p className="m-0">---------</p>
                  </div>
              </div>
          </div>
          <Link href="#/categories">
              <p className="btn btn-default waves-effect w-md btn-lg btn-block">Go to categories</p>
              </Link>
      </div>
    </ReactCSSTransitionGroup>
        );

}

Result.propTypes = {
    quizResult: React.PropTypes.number.isRequired,
};

export default Result;



// WEBPACK FOOTER //
// ./react/app/Components/Result.js